import { malfunctionsSlice } from "./malfunctionsSlice";
import * as actions from "./malfunctionsActions";
import * as selectors from "./malfunctionsSelectors";

export { actions };
export { selectors };
export default malfunctionsSlice.reducer;
